import { motion } from 'framer-motion';
import { Check, X, Target } from 'lucide-react';

const forYou = [
  'Lelah mencoba strategi yang acak',
  'Mencari struktur, bukan hype',
  'Lebih nyaman dengan aturan daripada emosi',
  'Ingin sistem yang bisa diulang dengan disiplin',
  'Ingin trading serius untuk jangka panjang'
];

const notFor = [
  'Pemburu sinyal instan',
  'Spekulan all-in',
  'Pencari profit semalam'
];

const WhoThisIsFor = () => {
  return (
    <section 
      className="py-24 md:py-32 relative overflow-hidden"
      data-testid="who-this-is-for-section"
    >
      {/* Ambient background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-tc-surface/10 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16 relative z-10">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-tc-primary/10 border border-tc-primary/20 backdrop-blur-md mb-8"
          >
            <Target className="w-5 h-5 text-tc-primary" />
            <span className="text-sm text-tc-primary font-bold tracking-wider uppercase">UNTUK SIAPA KAMI HADIR?</span>
          </motion.div>
          
          <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-white mb-6">
            Trading untuk <span className="text-tc-primary">hasil</span>, bukan gaya
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* For You */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="glass-card rounded-2xl p-8">
              <h3 className="text-xl font-heading font-semibold text-tc-secondary mb-8">
                Cocok Untuk
              </h3>
              <ul className="space-y-5">
                {forYou.map((item, idx) => (
                  <motion.li
                    key={idx}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: idx * 0.1 }}
                    className="flex items-center gap-4"
                  >
                    <div className="w-8 h-8 rounded-lg bg-tc-secondary/10 flex items-center justify-center flex-shrink-0">
                      <Check className="w-5 h-5 text-tc-secondary" />
                    </div>
                    <span className="text-tc-text-secondary text-lg">{item}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>

          {/* Not For */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="glass-card rounded-2xl p-8 border-red-500/10">
              <h3 className="text-xl font-heading font-semibold text-red-400 mb-8">
                Kurang Cocok Untuk
              </h3>
              <ul className="space-y-5">
                {notFor.map((item, idx) => (
                  <motion.li
                    key={idx}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.3 + idx * 0.1 }}
                    className="flex items-center gap-4"
                  >
                    <div className="w-8 h-8 rounded-lg bg-red-500/10 flex items-center justify-center flex-shrink-0">
                      <X className="w-5 h-5 text-red-400" />
                    </div>
                    <span className="text-tc-text-secondary text-lg">{item}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;
